<template>
  <b-row class="px-3">
    <!-- Fleet Category -->
    <b-col md="12" v-if="localFilters.vehicleTypeIds">
      <b-form-group
        label="Fleet Category"
        label-for="categoryId"
        label-cols-sm="4"
        label-cols-lg="3"
      >
        <v-multiselect
          v-model="localFilters.vehicleTypeIds"
          tag-placeholder="Fleets"
          placeholder="Select Fleets Category"
          label="name"
          track-by="code"
          :options="fleetCategoryOpt"
          :multiple="true"
          :taggable="true"
        />
      </b-form-group>
    </b-col>

    <!-- Fleet Name -->
    <b-col md="12" v-if="localFilters.vehicleIds">
      <b-form-group
        label="Fleet Name"
        label-for="vehicleIds"
        label-cols-sm="4"
        label-cols-lg="3"
      >
        <v-multiselect
          v-model="localFilters.vehicleIds"
          tag-placeholder="Fleets"
          placeholder="Select Fleets"
          label="name"
          track-by="code"
          :options="fleetNameOpt"
          :multiple="true"
          :taggable="true"
        />
      </b-form-group>
    </b-col>

    <!-- Equipment Category -->
    <b-col md="12" v-if="localFilters.master_component_ids">
      <b-form-group
        label="Equipment Category"
        label-for="equipmentCategoryIds"
        label-cols-sm="4"
        label-cols-lg="3"
      >
        <v-multiselect
          v-model="localFilters.master_component_ids"
          tag-placeholder="Equipment Categories"
          placeholder="Select Equipment Category"
          label="name"
          track-by="code"
          :options="equipmentCategoryList"
          :multiple="true"
          :taggable="true"
        />
      </b-form-group>
    </b-col>

    <!-- Equipment Name -->
    <b-col md="12" v-if="localFilters.component_ids">
      <b-form-group
        label="Equipment Name"
        label-for="equipmentIds"
        label-cols-sm="4"
        label-cols-lg="3"
      >
        <v-multiselect
          v-model="localFilters.component_ids"
          tag-placeholder="Fleets"
          placeholder="Select Equipment Name"
          label="name"
          track-by="code"
          :options="equipmentList"
          :multiple="true"
          :taggable="true"
        />
      </b-form-group>
    </b-col>

    <!-- Status -->
    <b-col md="12">
      <b-form-group
        label="Status"
        label-for="status"
        label-cols-sm="4"
        label-cols-lg="3"
      >
        <b-form-select
          plain
          :options="statusList"
          v-model="localFilters.status"
        />
      </b-form-group>
    </b-col>

    <!-- Method -->
    <b-col md="12" v-if="localFilters.method">
      <b-form-group
        label="Method"
        label-for="method"
        label-cols-sm="4"
        label-cols-lg="3"
      >
        <b-form-select
          plain
          :options="methodOptions"
          v-model="localFilters.method"
        />
      </b-form-group>
    </b-col>

    <!-- Filter Options -->
    <b-col md="12" v-if="localFilters.filterJobType">
      <b-form-group
        label="Filter Options"
        label-for="ownership"
        label-cols-sm="4"
        label-cols-lg="3"
      >
        <div class="d-flex">
          <b-form-radio
            v-model="localFilters.filterJobType"
            name="radio-a"
            class="mr-3"
            value="jobClass"
          >
            Job Class
          </b-form-radio>
          <b-form-radio
            v-model="localFilters.filterJobType"
            name="radio-b"
            value="jobType"
          >
            Job Type
          </b-form-radio>
        </div>
      </b-form-group>
    </b-col>

    <!-- Job Class / Job Type -->
    <b-col md="12" v-if="localFilters.filterJobType === 'jobClass'">
      <b-form-group
        label="Job Class"
        label-for="job-class"
        label-cols-sm="4"
        label-cols-lg="3"
      >
        <v-multiselect
          v-model="localFilters.jobClassIds"
          placeholder="Search job class"
          label="name"
          id="job-class"
          track-by="code"
          :options="jobClassList"
          :multiple="true"
          :taggable="true"
        />
      </b-form-group>
    </b-col>

    <b-col md="12" v-else-if="localFilters.filterJobType === 'jobType'">
      <b-form-group
        label="Job Type"
        label-for="job-type"
        label-cols-sm="4"
        label-cols-lg="3"
      >
        <v-multiselect
          v-model="localFilters.jobTypeIds"
          placeholder="Select job type"
          label="name"
          id="job-type"
          track-by="code"
          :options="jobTypeList"
          :multiple="true"
          :taggable="true"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  filesActions,
  fleetsActions,
  maintenanceActions,
  pmsActions,
} from '@/src/Utils/helper'

export default {
  name: 'FilterMaintenance',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fleetCategoryOpt: [],
      fleetNameOpt: [],
      statusList: [
        { value: null, text: 'All' },
        { value: 'MAINTENANCE', text: 'Progress' },
        { value: 'ACTIVE', text: 'Active' },
        { value: 'TOWARDS', text: 'Toward Maintenance' },
        { value: 'OVERDUE', text: 'Overdue' },
        { value: 'POSTPONE', text: 'Postponed' },
        { value: 'REJECT', text: 'Reject' },
      ],
      methodOptions: [
        { value: null, text: 'All' },
        { value: 'CALENDAR', text: 'Calendar' },
        { value: 'COUNTER', text: 'Counter' },
      ],
      jobClassList: [],
      jobTypeList: [],
      equipmentCategoryList: [],
      equipmentList: [],
    }
  },
  methods: {
    ...fleetsActions,
    ...maintenanceActions,
    ...filesActions,
    ...pmsActions,
    async fetchFleets() {
      let params = {
        page: 1,
        perPage: 1000,
        active: true,
      }
      try {
        this.fleetNameOpt = []
        const res = await this.getFleets(params)
        res.data.forEach((el) => {
          el.componentSetup = []
          this.fleetNameOpt.push({
            name: el.name,
            code: el.id,
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
    async fetchFleetCategories() {
      let params = {
        page: 1,
        perPage: 1000,
      }
      try {
        this.fleetCategoryOpt = []
        const res = await this.getFleetTypes(params)
        res.data.forEach((el) => {
          el.componentSetup = []
          this.fleetCategoryOpt.push({
            name: el.name,
            code: el.id,
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
    async getJobClassList() {
      const params = {
        page: 1,
        perPage: 1000,
      }

      try {
        this.jobClassList = []
        const res = await this.getJobClass(params)
        res.data.data.forEach((el) => {
          this.jobClassList.push({
            name: `${el.jobClassCode} - ${el.jobClass}`,
            code: el.id,
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
    async getJobTypeList() {
      try {
        const params = {
          page: 1,
          perPage: 1000,
        }
        this.jobTypeList = []
        const res = await this.getJobType(params)
        res.data.data.forEach((el) => {
          this.jobTypeList.push({
            name: `${el.jobTypeCode} - ${el.jobTypeIndex}`,
            code: el.id,
          })
        })
      } catch (error) {
        console.log(error)
      }
    },

    async fetchCategory() {
      const params = {
        limit: 9999,
        page: 1,
      }
      const res = await this.getEquipmentCategory(params)
      if (res.status === 'success') {
        const filteredData = res.data.data
        this.equipmentCategoryList = filteredData.map((el) => ({
          name: el?.component_name,
          code: el.id,
        }))
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async fetchMasterEquipment() {
      const params = {
        limit: 9999,
        page: 1,
      }
      const res = await this.getEquipment(params)
      if (res.status === 'success') {
        const { data } = res.data
        console.log({ data })

        this.equipmentList = data.map((el) => ({
          name: el?.equipment_name,
          code: el.id,
        }))
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },
  },
  computed: {
    localFilters: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  mounted() {
    this.fetchFleets()
    this.fetchFleetCategories()
    this.getJobClassList()
    this.getJobTypeList()
    this.fetchCategory()
    this.fetchMasterEquipment()
  },
}
</script>
